/*
  Barbarana - Consulta de frete por CEP na pagina de produto.
  Cria um carrinho temporario via Storefront API apenas com o produto visualizado,
  le as opcoes de entrega para o CEP informado e descarta o carrinho.
  A sacola do cliente nao e alterada em momento algum.
*/
(function () {
  if (window.BarbaranaFreteCep) {
    window.BarbaranaFreteCep.scan();
    return;
  }

  // Faixas de CEP -> UF (Correios), usadas para enviar o estado junto do CEP.
  var BR_ZIP_RANGES = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'],
    [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
    [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'],
    [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'],
    [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
    [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'],
    [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'],
    [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'],
    [90000, 99999, 'RS']
  ];

  var CREATE_QUERY = [
    'mutation BarbaranaCepQuote($lines: [CartLineInput!]!, $address: CartDeliveryAddressInput!, $country: CountryCode!) {',
    '  cartCreate(input: {',
    '    lines: $lines,',
    '    buyerIdentity: { countryCode: $country },',
    '    delivery: { addresses: [{ address: { deliveryAddress: $address }, selected: true, oneTimeUse: true, validationStrategy: COUNTRY_CODE_ONLY }] }',
    '  }) {',
    '    cart {',
    '      id',
    '      deliveryGroups(first: 10) { nodes { deliveryOptions { handle title description estimatedCost { amount currencyCode } } } }',
    '    }',
    '    userErrors { field message }',
    '  }',
    '}'
  ].join('\n');

  var RATES_QUERY = [
    'query BarbaranaCepRates($cartId: ID!) {',
    '  cart(id: $cartId) { id ...BarbaranaCarrierRates @defer }',
    '}',
    'fragment BarbaranaCarrierRates on Cart {',
    '  deliveryGroups(first: 10, withCarrierRates: true) {',
    '    nodes { deliveryOptions { handle title description estimatedCost { amount currencyCode } } }',
    '  }',
    '}'
  ].join('\n');

  var cache = {};
  var addressCache = {};

  function onlyDigits(value) {
    return (value || '').toString().replace(/\D/g, '');
  }

  function maskCep(value) {
    var d = onlyDigits(value).slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }

  function ufFromCep(cep) {
    var d = onlyDigits(cep);
    if (d.length < 5) return null;
    var prefix = parseInt(d.slice(0, 5), 10);
    if (isNaN(prefix)) return null;
    for (var i = 0; i < BR_ZIP_RANGES.length; i++) {
      if (prefix >= BR_ZIP_RANGES[i][0] && prefix <= BR_ZIP_RANGES[i][1]) return BR_ZIP_RANGES[i][2];
    }
    return null;
  }

  function escapeHtml(value) {
    return (value == null ? '' : String(value))
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(amount, currency, freeLabel) {
    var n = parseFloat(amount);
    if (!isNaN(n) && n === 0) return freeLabel;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: currency || 'BRL'
      }).format(isNaN(n) ? 0 : n);
    } catch (e) {
      return (currency || '') + ' ' + amount;
    }
  }

  // Endereco resolvido a partir do CEP (ViaCEP), so para exibicao - nao afeta a cotacao.
  function fetchAddress(cep) {
    if (addressCache[cep]) return Promise.resolve(addressCache[cep]);
    return fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || data.erro) return null;
        addressCache[cep] = data;
        return data;
      })
      .catch(function (error) {
        console.warn('[barbarana-frete-cep] endereco:', error);
        return null;
      });
  }

  function formatAddress(data) {
    if (!data) return '';
    var line = data.logradouro || '';
    if (data.bairro) line = line ? line + ', ' + data.bairro : data.bairro;
    var parts = [line, data.localidade, data.uf];
    return parts.filter(function (part) { return !!part; }).join(' – ');
  }

  function showAddress(root, data) {
    var box = root.querySelector('[data-cep-address]');
    if (!box) return;
    var text = formatAddress(data);
    if (!text) {
      box.classList.add('bb-cep-is-hidden');
      return;
    }
    var textEl = box.querySelector('[data-cep-address-text]');
    if (textEl) textEl.textContent = text;
    box.classList.remove('bb-cep-is-hidden');
  }

  function productForm(root) {
    var scope = root.closest('.shopify-section') || document;
    return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function currentVariantId(root) {
    var form = productForm(root);
    var input = form && form.querySelector('[name="id"]:not([disabled])');
    var value = input && input.value;
    return onlyDigits(value) || root.dataset.defaultVariant;
  }

  function currentQuantity(root) {
    var form = productForm(root);
    var input = form && form.querySelector('[name="quantity"]');
    var n = input ? parseInt(input.value, 10) : 1;
    return !n || n < 1 ? 1 : n;
  }

  // A Storefront API devolve multipart/mixed quando a query usa @defer.
  function parsePayloads(contentType, text) {
    if (!/multipart\/mixed/i.test(contentType || '')) {
      try { return [JSON.parse(text)]; } catch (e) { return []; }
    }
    var match = (contentType || '').match(/boundary=(?:"([^"]+)"|([^;]+))/i);
    var boundary = '--' + ((match && (match[1] || match[2]) || 'graphql').trim());
    var payloads = [];
    text.split(boundary).forEach(function (chunk) {
      var idx = chunk.indexOf('\r\n\r\n');
      var offset = 4;
      if (idx === -1) { idx = chunk.indexOf('\n\n'); offset = 2; }
      if (idx === -1) return;
      var body = chunk.slice(idx + offset).replace(/--\s*$/, '').trim();
      if (!body) return;
      try { payloads.push(JSON.parse(body)); } catch (e) { /* chunk parcial */ }
    });
    return payloads;
  }

  function collectOptions(node, out, seen) {
    if (!node || typeof node !== 'object') return;
    if (Array.isArray(node)) {
      node.forEach(function (item) { collectOptions(item, out, seen); });
      return;
    }
    if (Array.isArray(node.deliveryOptions)) {
      node.deliveryOptions.forEach(function (option) {
        var key = option.handle || option.title;
        if (key && seen.indexOf(key) === -1) { seen.push(key); out.push(option); }
      });
    }
    Object.keys(node).forEach(function (key) {
      if (key !== 'deliveryOptions') collectOptions(node[key], out, seen);
    });
  }

  async function fetchRates(root, variantId, quantity, cep) {
    var endpoint = '/api/' + (root.dataset.apiVersion || '2026-07') + '/graphql.json';
    var headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json, multipart/mixed',
      'X-Shopify-Storefront-Access-Token': root.dataset.token
    };
    var country = (root.dataset.country || 'BR').toUpperCase();
    var address = { countryCode: country, zip: cep.slice(0, 5) + '-' + cep.slice(5) };
    var uf = ufFromCep(cep);
    if (country === 'BR' && uf) address.provinceCode = uf;

    var merchandiseId = String(variantId).indexOf('gid://') === 0
      ? variantId
      : 'gid://shopify/ProductVariant/' + variantId;

    var createResponse = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        query: CREATE_QUERY,
        variables: {
          lines: [{ merchandiseId: merchandiseId, quantity: quantity }],
          address: address,
          country: country
        }
      })
    });

    var createJson = await createResponse.json();
    var payload = createJson && createJson.data && createJson.data.cartCreate;

    if (!payload || !payload.cart) {
      throw new Error(JSON.stringify(
        (createJson && createJson.errors) || (payload && payload.userErrors) || 'cartCreate sem retorno'
      ));
    }

    var options = [];
    var seen = [];
    collectOptions(payload.cart, options, seen);

    // Rates calculadas por transportadora/app so vem com withCarrierRates + @defer.
    try {
      var ratesResponse = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ query: RATES_QUERY, variables: { cartId: payload.cart.id } })
      });
      var contentType = ratesResponse.headers.get('content-type');
      var body = await ratesResponse.text();
      parsePayloads(contentType, body).forEach(function (chunk) {
        collectOptions(chunk.data, options, seen);
        collectOptions(chunk.incremental, options, seen);
      });
    } catch (error) {
      console.warn('[barbarana-frete-cep] carrier rates:', error);
    }

    return options;
  }

  function setLoading(root, isLoading) {
    var button = root.querySelector('[data-cep-submit]');
    var spinner = root.querySelector('[data-cep-spinner]');
    root.classList.toggle('bb-cep-is-loading', isLoading);
    if (button) button.disabled = isLoading;
    if (spinner) spinner.classList.toggle('bb-cep-is-hidden', !isLoading);
  }

  function showError(root, message) {
    var box = root.querySelector('[data-cep-error]');
    var results = root.querySelector('[data-cep-results]');
    if (results) results.classList.add('bb-cep-is-hidden');
    if (!box) return;
    box.textContent = message;
    box.classList.remove('bb-cep-is-hidden');
  }

  function clearMessages(root) {
    var box = root.querySelector('[data-cep-error]');
    if (box) box.classList.add('bb-cep-is-hidden');
  }

  function showRates(root, options) {
    clearMessages(root);
    var results = root.querySelector('[data-cep-results]');
    if (!results) return;

    if (!options.length) {
      results.classList.add('bb-cep-is-hidden');
      showError(root, root.dataset.msgEmpty);
      return;
    }

    var showDescription = root.dataset.showDescription === 'true';
    var freeLabel = root.dataset.msgFree;

    results.innerHTML = '<ul class="bb-cep-list">' + options.map(function (option) {
      var price = option.estimatedCost
        ? formatMoney(option.estimatedCost.amount, option.estimatedCost.currencyCode, freeLabel)
        : '';
      var description = showDescription && option.description
        ? '<span class="bb-cep-desc">' + escapeHtml(option.description) + '</span>'
        : '';
      return '<li class="bb-cep-item"><span><span class="bb-cep-item-title">' + escapeHtml(option.title || '') + '</span>' + description +
        '</span><span class="bb-cep-price">' + escapeHtml(price) + '</span></li>';
    }).join('') + '</ul>';

    results.classList.remove('bb-cep-is-hidden');
  }

  async function quote(root) {
    var input = root.querySelector('[data-cep-input]');
    if (!input) return;

    var cep = onlyDigits(input.value);
    if (cep.length !== 8) {
      showAddress(root, null);
      showError(root, root.dataset.msgInvalid);
      return;
    }

    if (!root.dataset.token) {
      console.warn('[barbarana-frete-cep] storefront_token nao configurado no bloco.');
      showError(root, window.Shopify && window.Shopify.designMode
        ? 'Configure o storefront_token no bloco para o calculo funcionar.'
        : root.dataset.msgError);
      return;
    }

    var variantId = currentVariantId(root);
    var quantity = currentQuantity(root);
    var key = variantId + '|' + quantity + '|' + cep;

    // Endereco e frete sao independentes: um nao bloqueia o outro.
    fetchAddress(cep).then(function (data) { showAddress(root, data); });

    if (cache[key]) {
      showRates(root, cache[key]);
      return;
    }

    setLoading(root, true);
    clearMessages(root);

    try {
      var options = await fetchRates(root, variantId, quantity, cep);
      cache[key] = options;
      showRates(root, options);
    } catch (error) {
      console.warn('[barbarana-frete-cep]', error);
      showError(root, root.dataset.msgError);
    } finally {
      setLoading(root, false);
    }
  }

  function bind(root) {
    if (root.dataset.cepBound === '1') return;
    root.dataset.cepBound = '1';

    var input = root.querySelector('[data-cep-input]');
    var button = root.querySelector('[data-cep-submit]');

    if (input) {
      input.addEventListener('input', function () { input.value = maskCep(input.value); });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); quote(root); }
      });
    }
    if (button) {
      button.addEventListener('click', function (event) { event.preventDefault(); quote(root); });
    }
  }

  function scan() {
    document.querySelectorAll('[data-cep-frete]').forEach(bind);
  }

  window.BarbaranaFreteCep = { scan: scan, quote: quote };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();